import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsNnCEvG8S9MGrGq+Yo8C
fxoPwGxskWAqQouQ0WxjGmRMXqNt82MUdOtS4EjBzpMnY/AO4+rCC4ozGoCKq2kx
yXRvf/Ik79TsA0CgwQ7upzYUppueUTHo8WILeKNFszGi9YTmHVzWbH9Ys1Ja0GGr
cjd2fvxUrInaLwSrysoBjFQRBCs4G7mdFHyQ19y9kHh80Ltkqy5oD5GNd9MJm2/z
FBTspZzG4oiUlhyx9MeBIi4O+kshmPcjvw5f5BZZ9L9i9oY7HrOuPFnbF1mRRtlq
ZGbmXl6YZY7Kb8znvxJ1sHXZ0zCgOoqPdOujW0ZoP+YuvWM6NmSdKCQ0BLgIOb4K
BwIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

